var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',{attrs:{"name":_vm.name,"width":"60%","title":"Find Patient"},on:{"closed":_vm.close}},[[_c('PatientsTable',{attrs:{"modal":""}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }